import { Box, Flex, Image } from '@chakra-ui/react';
import React, { Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';

import MenuMachine from '@/components/Menu/MenuMachine';
import { COMMON_WEB_PATH } from '@/constant';
import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';

import GameSelector from '../../components/GameComponents/GameSelector/GameSelector';
import GameSlideSelector from '../../components/GameComponents/GameSelector/GameSlideSelector';
import GameTypeSelector from '../../components/GameComponents/GameTypeSelector/GameTypeSelector';
import LeaderBoardWrapper from '../../components/GameComponents/LeaderBoard/LeaderBoardWrapper';
import TopGameBoard from '../../components/GameComponents/TopGameBoard/TopGameBoard';
import MarqueeList from '../../components/marquee/MarqueeList';
import useDeviceType from '../../hook/useDeviceType';
import Seo from '../Slot/seo';
import HotTypeMenu from './components/HotTypeMenu/HotTypeMenu';

const Home = () => {
  const isMobile = useDeviceType() === 'Mobile';
  const isTablet = useDeviceType() === 'Tablet';
  const isPC = useDeviceType() === 'PC';

  const [searchParams] = useSearchParams();

  const searchParamsType = searchParams.get('type') || 'Popular';

  const isLandscapeMachine = useIsLandScapeMachine();

  return (
    <Fragment>
      <Box display="flex" flexDirection="column">
        <Box minH="0" display="flex" flexDirection="column">
          <Seo />

          <Flex>
            <Box
              flex={1}
              justifyContent="space-between"
              alignItems="center"
              gap="5px"
              px={{
                base: '10px',
                md: '0px'
              }}
              flexDirection={'column'}
              maxW="70%"
              mx="auto"
              // my="5px"
            >
              <MarqueeList />{' '}
            </Box>
          </Flex>
        </Box>
        <Flex flex={1}>
          <MenuMachine />
          <Flex flex={1} overflow="hidden" flexDirection={'column'}>
            <Flex gap="10px">
              {isLandscapeMachine && (
                <Image
                  src={`${COMMON_WEB_PATH}/blue-layout/logo_192.png`}
                  alt="Logo"
                  objectFit="contain"
                  width="100%"
                  maxW={{
                    base: '85px',
                    md: '140px'
                  }}
                  height="100%"
                />
              )}
              <LeaderBoardWrapper>
                <TopGameBoard />
              </LeaderBoardWrapper>
            </Flex>
            <Box
              display={{
                base: 'flex',
                md: 'block'
              }}
            >
              <Box
                py={{
                  base: '0'
                }}
                display={{
                  base: 'block',
                  sm: 'none'
                }}
                pr="5px"
              >
                <GameTypeSelector gameMainTypeFromProps={'SLOT'} />
              </Box>
              <Flex
                overflowX={{
                  base: 'scroll',
                  lg: 'hidden'
                }}
                flex={1}
                justifyContent="space-between"
                gap="10px"
              >
                <Box
                  flex="none" // 確保這部分不會被拉伸
                  w={{
                    base: '100%'
                    // xl: "calc(100% - 150px)",
                  }}
                  py={{
                    base: 0,
                    md: 'home-space'
                  }}
                  mb={{
                    base: '60px',
                    sm: '0px'
                  }}
                >
                  {isPC || isTablet ? (
                    <>
                      <Box mt="20px" display={{ base: 'none', md: 'block' }}>
                        <GameSlideSelector />
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box display={{ base: 'block', xl: 'block' }}>
                        <Box
                          display={{
                            base: 'block',
                            md: 'none'
                          }}
                        >
                          <HotTypeMenu />
                        </Box>
                        <Box id="HOT">
                          <GameSelector
                            // gameMainTypeFromProps={"HOT"}
                            hiddenTitle
                            customSubType={searchParamsType}
                            isHighlight
                            sliceCount={10}
                            isHot
                            topLayout={!isMobile && !isTablet}
                            // isGridXLayout
                          />
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Fragment>
  );
};

export default Home;
